import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';

export class Decision {
    static jsonMap = {
        dateTransmission: { key: 'dateTransmission', converter: new DateConverter(), optional: true },
        dateDecision: { key: 'dateDecision', converter: new DateConverter(), optional: true },
        applicationSanction: { key: 'applicationSanction', optional: true },
        auteur: { key: 'auteurDecision', optional: true, default: '' },
        commentaire: { key: 'commentaireDecision', optional: true, default: '' },
        idSanction: { key: 'idSanctionAppliquee', optional: true }
    };

    dateTransmission: moment.Moment;
    dateDecision: moment.Moment;
    applicationSanction: boolean;
    auteur: string;
    commentaire: string;
    idSanction: number;
}
